import { Project } from '../../../types';
import { formatDate } from '../../../utils/formatDate';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface ProjectInfoSummaryProps {
  project: Project;
  t: Translate;
}

export default function ProjectInfoSummary({
  project,
  t,
}: ProjectInfoSummaryProps) {
  const projectType = project.projectType || 'animation';

  return (
    <div className="project-info-summary" style={{ flex: 'none', width: '65%', minWidth: 0 }}>
      {/* 第一行：类型徽标 + 标题 + ID/复制/比例/创建时间/拥有者（同一行） */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', fontSize: '0.75rem', color: 'var(--text-3)', marginBottom: project.projectPrompt ? '0.5rem' : 0 }}>
        <span style={{ fontSize: '0.75rem', fontWeight: 500, padding: '2px 8px', borderRadius: '6px', background: projectType === 'real_person' ? 'rgba(239,68,68,0.1)' : 'rgba(59,130,246,0.1)', color: projectType === 'real_person' ? 'var(--danger)' : 'var(--primary)', flexShrink: 0 }}>
          {projectType === 'real_person' ? t('project.realPerson') : t('project.animation')}
        </span>
        <h2 style={{ margin: 0, lineHeight: 1.3, wordBreak: 'break-all', fontSize: '1.1rem', color: 'var(--text)' }}>{project.name}</h2>
        <span style={{ fontFamily: 'monospace' }}>ID: {project.id}</span>
        <button
          title={t('project.copyId')}
          onClick={() => { navigator.clipboard.writeText(project.id); const el = document.getElementById('copy-id-btn'); if (el) { el.textContent = t('project.copied'); setTimeout(() => { el.textContent = t('project.copy'); }, 1500); } }}
          id="copy-id-btn"
          style={{ fontSize: '0.68rem', padding: '1px 6px', borderRadius: '4px', border: '1px solid var(--border)', background: 'var(--bg)', color: 'var(--text-3)', cursor: 'pointer', lineHeight: '1.4' }}
        >
          {t('project.copy')}
        </button>
        {project.aspectRatio && (
          <>
            <span style={{ color: 'var(--border)' }}>|</span>
            <span style={{ fontWeight: 500, padding: '1px 6px', borderRadius: '4px', background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text-2)' }}>
              {project.aspectRatio}
            </span>
          </>
        )}
        <span style={{ color: 'var(--border)' }}>|</span>
        <span>{t('project.createdAt', { date: formatDate(project.createdAt) })}</span>
        {project.ownerName && (
          <>
            <span style={{ color: 'var(--border)' }}>|</span>
            <span>{t('project.owner', { name: project.ownerName })}</span>
          </>
        )}
      </div>

      {/* 第二行：项目描述（无描述则整块只占一行） */}
      {project.projectPrompt && (
        <p style={{ margin: 0, color: 'var(--text-2)', fontSize: '0.85rem' }}>
          {project.projectPrompt}
        </p>
      )}
    </div>
  );
}
